import { render, staticRenderFns } from "./siderMenu.vue?vue&type=template&id=5703e46a&scoped=true"
import script from "./siderMenu.vue?vue&type=script&lang=js"
export * from "./siderMenu.vue?vue&type=script&lang=js"
import style0 from "./siderMenu.vue?vue&type=style&index=0&id=5703e46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703e46a",
  null
  
)

export default component.exports